var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgChevronLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.08 20.857l.781-.805a.498.498 0 000-.69L9.725 12l7.136-7.363a.498.498 0 000-.69l-.782-.804a.464.464 0 00-.67 0l-8.27 8.512a.498.498 0 000 .69l8.27 8.512c.185.19.485.19.67 0z",
    fill: "#028BB7"
  })));
}

export default SvgChevronLeft;